import { connect } from 'react-redux';

import BaseComponent from '../../../components/BaseComponent';
import { bulkMailSenderConfig } from '../../../entity/HRM/bulkMailSenderConfig';

class BulkMailSender extends BaseComponent {
  constructor(props) {
    super(props);
    this.config = { ...bulkMailSenderConfig };
    this.getResponse();
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(BulkMailSender);
